export enum QuotaMetOrCloseActions {
    DoNothing = 0,
    DisplayMessageAndExit,
    RedirectToUrl,
}
